import { Component, OnInit, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ThirdPartyEvaluationFormItem } from '../../../../../../models/thirdparty-evaluation-form-item';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ThirdPartyEvaluationService } from '../../../../../../services/thirdparty-evaluation.service';
import { EvaluationFormItemType } from '../../../../../../models/due-diligence/evaluation-form-item-type.table';
import { TranslateService } from '@ngx-translate/core';
import { ThirdPartyTracingActionListItem } from '../../../../../../models/thirdparty-tracingaction-listitem';

interface IGetSpecialTaskDetail {
  task: ThirdPartyTracingActionListItem,
  evaluationId: number
}

@Component({
  selector: 'kt-special-task-detail-dialog',
  templateUrl: './special-task-detail-dialog.component.html',
  styleUrls: ['./special-task-detail-dialog.component.scss']
})
export class SpecialTaskDetailDialogComponent implements OnInit {
  pageLoading$: BehaviorSubject<boolean>;
  evaluationFormItems$: BehaviorSubject<ThirdPartyEvaluationFormItem[]>;
  savedFormAnswers$: BehaviorSubject<any[]>;
  evaluationForm: FormGroup;

  maxInputLength: number = 255;
  maxCommentLength: number = 255;

  constructor(
    private _evaluationService: ThirdPartyEvaluationService,
    private fb: FormBuilder,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<SpecialTaskDetailDialogComponent>,   
    @Inject(MAT_DIALOG_DATA) public data: IGetSpecialTaskDetail,
  ) {
    this.evaluationFormItems$ = new BehaviorSubject<ThirdPartyEvaluationFormItem[]>([]);
    this.savedFormAnswers$ = new BehaviorSubject<any[]>([]);
    this.pageLoading$ = new BehaviorSubject<boolean>(true);
    this.evaluationForm = this.fb.group({});
  }

  ngOnInit() {

    this._evaluationService.getSpecialTaskDetail(this.data.task, this.data.evaluationId).subscribe({
      next: res => {
        this.pageLoading$.next(false);
        
        this.buildAssociatedItems(
          this.reassembleFormItems(res.appFormItems),
          res.answers);
      }
    });


  }

  private buildAssociatedItems(appFormItems: ThirdPartyEvaluationFormItem[], answers: any[]) { 
    this.evaluationFormItems$.next(appFormItems);
    this.savedFormAnswers$.next(answers);
    this.createEvaluationForm(appFormItems, true, answers);
  }

  createEvaluationForm(
    formItems: ThirdPartyEvaluationFormItem[],
    formLocked?: boolean,
    formAnswers?: any[]){

    formLocked = formLocked || false;

    var form = {};
    for (const item of formItems) {
      /* #region Add-Validators */
      var validators = [];

      if (item.isRequired) {
        validators.push(Validators.required);        
      }

      // Sólo para el caso del TextInput
      if (item.itemTypeId == EvaluationFormItemType.Text) {
        validators.push(Validators.maxLength(this.maxInputLength));
      }
      /* #endregion */

      var formItem: any;
      var answer: any;
      var answerComment: any;
      
      // Si es una pregunta de selección múltiple va a tener hijos
      if (item.itemTypeId == EvaluationFormItemType.MultipleDropDownSelection) {
        answer = [];
        //Busco todos los hijos respondidos de esta pregunta y obtengo sus respuestas
        var currentItemChildAnswers = formAnswers? formAnswers.filter(x => x.appFormItemId == item.id) : [];
        var currentItemChildAnswersIds = currentItemChildAnswers? currentItemChildAnswers.map(x => x.appFormItemAnswerId as number) : [];
        
        for (const childId of currentItemChildAnswersIds) {
          // Obtengo el subitem que tiene ese childId
          var subItem =  item.appFormItemAnswers.find(y => {
                              var subItem = y.id as ThirdPartyEvaluationFormItem;
                              return subItem.appFormItemAnswers
                                      .map(x => x.id as number)
                                      .some(id => id == childId);   
                            }).id as ThirdPartyEvaluationFormItem;
          // Me quedo solamente con las selecciones que son True
          if (subItem.appFormItemAnswers.find(x => x.isTrue).id === childId){
            answer.push(subItem)
          }          
        }

        // Si no se respondio nada se hace un agrega un 'null' para denotora que 
        // 'ninguna opción elegida'
        if (!answer.length) {
          answer.push(Object.assign(new ThirdPartyEvaluationFormItem(), 
            {id: null, description: this.translate.instant('EVALUATION.MULTIPLE_SELECTION_ITEM_NO_SELECTION'), parentId: item.id }));
        }

        // Todas las subpreguntas deben tener el mismo comentario
        answerComment = currentItemChildAnswers.length > 0? currentItemChildAnswers[currentItemChildAnswers.length-1].observation : '';     
      }
      else {
        //Busco la pregunta correspondiente
        formItem = formAnswers? formAnswers.find(x => x.appFormItemId == item.id) : null;
        answer = formItem? formItem.appFormItemAnswerId : '';
        answerComment = formItem? formItem.observation : '';
      }

      // Reconstruyo la pregunta
      form[item.code] = [ { value: answer, disabled: formLocked }, validators ]

      // Agrege control para comentario si está disponible
      if (item.isCommentAvailable) {
        form[`${item.code}-comment`] = [ { value: answerComment, disabled: formLocked }, Validators.maxLength(this.maxCommentLength) ];
      }
    }

    this.evaluationForm = this.fb.group(form);
  }

  private reassembleFormItems(formItems: ThirdPartyEvaluationFormItem[]): ThirdPartyEvaluationFormItem[]{
    var reassembledFormItems: ThirdPartyEvaluationFormItem[] = formItems.filter(x => x.parentId == null);
    var subItems: ThirdPartyEvaluationFormItem[] = formItems.filter(x => x.parentId != null);
    for (const subItem of subItems) {
      reassembledFormItems
        .find(x => x.id == subItem.parentId)
        .appFormItemAnswers.push({
          id: Object.assign(new ThirdPartyEvaluationFormItem(), subItem) as ThirdPartyEvaluationFormItem,
          description: subItem.description,
          isCommentRequired: false
        });
    }

    return reassembledFormItems;
  }

}
